<template>
    <div v-if="configs.productAiCommentFeature && comment" class="w-full">
        <h2 class="text-base text-primary-dark font-bold pb-3 border-b border-primary-neutral">
          {{ $t('text-product-site-comment') }}
        </h2>
        <div class="prose max-w-none break-words py-4 pb-3 border-b border-primary-neutral text-sm" v-html="sanitizeLinks(markdownit(comment))" />
    </div>
</template>

<script setup>
import { useConfigStore } from '@stores/config';

const props = defineProps({
  variant: {
    type: Object,
    default: () => {}
  }
});

const configs = useConfigStore();

const comment = computed(() => localized(props.variant, 'comment'));

</script>
